<template>
  <Drawer title="Admin Panel">
    <div id="admin-settings-accordion">
      <AccordionButton title="Site Configuration" route="siteConfig"/>
      <AccordionButton title="User Management" route="userControl"/>
      <AccordionButton title="Cabinet Roles" route="accessControl"/>
    </div>
  </Drawer>
</template>

<script setup>
  import AccordionButton from "@/components/search-page/basket-action-drawer/AccordionButton.vue";
  import Drawer from "@/components/base-components/drawer/Drawer.vue";
</script>

<style scoped lang="scss">
  #admin-settings-accordion {
    min-width: 215px;

    .common-drawer-head:hover {
      background-color: rgba(0, 0, 0, 0.04);
    }
  }
</style>
